import { Component, OnInit, HostBinding } from '@angular/core';
import { StoresDataService } from '../../services/stores.data.service';
import { SnackbarService } from 'app/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { StoreListQuery, CompetitorShopListForOwnShopQuery } from '../../model/models';

import * as L from 'leaflet';
import { MatDialog } from '@angular/material/dialog';
import { DeleteModalComponent } from 'app/components/delete-modal/delete-modal.component';
import {ClusterModel} from 'app/prices/current-assortment/models/cluster.model';
import {CurrentAssortmentService} from 'app/prices/current-assortment/services/current-assortment.service';

const lat = 52.237049;
const lng = 21.017532;

const SHOP_EDITION_URL = 'metadata/stores/edition-store/';
const SHOP_BROWSER_URL = 'metadata/stores';

@Component({
    selector: 'pr-app-shop-page',
    templateUrl: './shop-page.component.html',
    styleUrls: ['./shop-page.component.scss'],
})
export class ShopPageComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow action-button-padding';

    competitorShops: Array<string>;
    compShopsIDsList: Array<number>;
    store: StoreListQuery = {} as StoreListQuery;
    storeLoc = '';
    competitorStores: CompetitorShopListForOwnShopQuery[] = [];
    competitorStoresAdd: string[] = [];
    dialogRef: any;

    isDeleting = false;

    options = {
        layers: [
            L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18 })
        ],
        zoom: 15,
        center: L.latLng([lat, lng])
        // center: L.latLng([])
    };

    mapCenter: { [name: string]: number } = {
        lng: lng,
        lat: lat
    };

    dataTableInfo: Array<any> = [];
    clusters: Array<ClusterModel>;

    constructor(
        public dataService: StoresDataService,
        public snackBar: SnackbarService,
        private route: ActivatedRoute,
        private _location: Location,
        private router: Router,
        public dialog: MatDialog,
        private currentAssortmentService: CurrentAssortmentService
    ) {
        this.dataTableInfo = StoreListQuery.getColumnInfo().columns;
    }


    ngOnInit() {
        this.route.data.subscribe(
            (data: { shop: StoreListQuery, competitors: CompetitorShopListForOwnShopQuery[] }) => {
                if (data.shop) {
                    this.store = data.shop;
                    this.storeLoc = this.initStoreLocation();
                }
                if (data.competitors) {
                    this.competitorStoresAdd = data.competitors.map(compShop => compShop.City + ' ' + compShop.AddressWithNR);
                    this.competitorStores = data.competitors;
                }
            }
        );

        this.currentAssortmentService
            .fetchClustersData()
            .subscribe((clusters) => {
                this.clusters = clusters.items;
            });
    }

    public getCluster(clusterId: number) {
        return this.clusters?.find(x => x.id === clusterId);
    }

    private initStoreLocation(): string {
        if (!this.store.City || !this.store.AddressWithNR) {
            return null;
        }
        return this.store.City + ' ' + this.store.AddressWithNR;
    }

    sendBack() {
        this._location.back();
    }

    compShops(shops) {
        this.competitorShops = shops.map(shop => shop.CompStoreAddress);
    }

    public goBack() {
        this._location.back();
    }

    public deleteShop(): void {
        this.isDeleting = true;
        this.dataService.delete(this.store.Id)
            .subscribe(
                () => this.shopDeleted(),
                err => this.shopError(err),
                () => this.isDeleting = false
            );
    }

    public openDialog(): void {
        this.dialogRef = this.dialog.open(DeleteModalComponent, {
            width: '250px',
            data: { name: this.store.Name, id: this.store.Id, dataService: this.dataService },
        });

        this.dialogRef.afterClosed().subscribe(result => {
            if (result.deleted) {
                this.deleteShop();
            }
        });
    }

    private shopDeleted(): void {
        this.snackBar.info(`${this.store.Name} został usunięty.`);
        this.router.navigateByUrl(SHOP_BROWSER_URL);
    }

    private shopError(err: HttpErrorResponse) {
        this.isDeleting = false;
        if (err.status === 409) {
            this.snackBar.info('Nie można usunąć placówki z referencjami.');
        } else if (err.status !== 403) {
            this.snackBar.info('Wystąpił błąd podczas usuwania.');
        }
    }

    public navToEdit(): void {
        this.router.navigateByUrl(`${SHOP_EDITION_URL}${this.store.Id}`);
    }
}
